/**
 * LogoRight Component
 *
 * Right half of the THIS + THAT logo door (568x164px).
 * Cream fills baked into the SVG. Includes edge strip.
 * Parent clip container in Board.tsx hides the edge strip when doors are closed.
 */

import React from 'react';
import SvgLogoDoorRightNew from './LogoDoorRightNew';

interface LogoRightProps {
  style?: React.CSSProperties;
}

const LogoRight: React.FC<LogoRightProps> = ({ style }) => (
  <SvgLogoDoorRightNew
    style={{
      position: 'absolute',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      ...style,
    }}
  />
);

export default LogoRight;
